<section id="skills" class="py-24 sm:py-32 bg-surface">
  <div class="container mx-auto px-6 lg:px-10">
    <!-- Section header -->
    <div class="flex items-center gap-4 mb-14" data-aos="fade-up" data-aos-delay="200">
      <span class="font-mono text-[10px] text-accent/40 tracking-widest select-none">///</span>
      <span class="text-accent font-mono text-sm">04</span>
      <h2 class="text-3xl sm:text-4xl font-display font-black text-text-strong">
        {{ "skills.title" | translate }}
      </h2>
      <span class="flex-1 h-px bg-subtle"></span>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      @for (key of skillKeys; track key) {
        <div class="bg-surface-100/60 border border-subtle rounded-xl p-6 hover:border-accent/20 transition-colors duration-300 group" data-aos="flip-left" [attr.data-aos-delay]="150 + ($index * 100)">
          <div class="flex items-center gap-3 mb-4">
            <span class="w-9 h-9 rounded-lg bg-accent/10 border border-accent/20 text-accent flex items-center justify-center text-sm">
              <i [class]="getIconClass(key)" aria-hidden="true"></i>
            </span>
            <h3 class="text-base font-display font-bold text-text-strong">
              {{ skills[key]?.title }}
            </h3>
          </div>
          <ul class="space-y-1.5 text-sm">
            @for (item of skills[key]?.list; track $index) {
              <li class="flex items-start gap-2 text-muted-light">
                <span class="text-accent text-xs mt-0.5">&#9656;</span>
                <span>{{ item }}</span>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
</section>
